/*
 * Project: Dynamedics Portal Web
 * Created Date: Monday July 5th 2021
 * Author: Chamudi Vidanagama
 * -----
 * Last Modified: Monday July 5th 2021 10:22:44 am
 * Modified By: Chamudi Vidanagama at <cvidanagama@mitrai.com>
 * -----
 * Copyright (c) 2021 Mitra Sparks
 * -----
 * HISTORY:
 */

import faker from 'faker';
import { sample } from 'lodash';
import mock from 'src/utils/mock';
import fakeRequest from '../utils/fakeRequest';

// ----------------------------------------------------------------------

const EXPERIENCE_CATEGORY = [
  'Physical & Emotional Wellbeing',
  'Financial Wellbeing',
  'Environment & Ways Of Working',
  'Technology',
  'Leadership & Culture',
  'Strategy & Change Management',
  'Career Wellbeing',
  'Rewards & Benefits'
];

const EMPLOYEES = [
  'Tyler Brady',
  'Billy Harper',
  'Mia Chambers',
  'Toby Khan',
  'Harry Murphy',
  'Louis Thomas',
  'Harrison Townsend',
  'Sienna Allen',
  'Lily Sullivan',
  'Thomas Robson',
  'Kate Gray',
  'Oliver Reid',
  'Samuel Clayton',
  'Maisie Jackson',
  'Harley Rowe',
  'Jamie Pearson',
  'Liam Farrell',
  "Adam O'Sullivan",
  'Isabella Welch',
  'Aaron Flynn',
  'Evan Kennedy',
  'Ellis Burgess',
  'Cameron Akhtar',
  'Lydia Mellor',
  'Rachel Howarth',
  'Archie Reynolds',
  'Chelsea Bolton',
  'Eva Moss',
  'Anthony Macdonald',
  'Sienna Whitehead'
];

const requests = [...Array(15)].map((_, index) => {
  const setIndex = index + 1;
  return {
    id: `${setIndex}`,
    date: faker.date.past(),
    request: `Request to join ${sample(EXPERIENCE_CATEGORY)}`,
    requestedBy: sample(EMPLOYEES)
  };
});

const questions = [...Array(22)].map((_, index) => {
  const setIndex = index + 1;
  return {
    id: `${setIndex}`,
    date: faker.date.past(),
    subject: `${sample(EXPERIENCE_CATEGORY)}`,
    question: `How does ${sample(
      EXPERIENCE_CATEGORY
    )} affects my company in the long run to benefit all of its' employees?`,
    raisedBy: sample(EMPLOYEES)
  };
});

const feedBacks = [...Array(22)].map((_, index) => {
  const setIndex = index + 1;
  return {
    id: `${setIndex}`,
    date: faker.date.past(),
    subject: `${sample(EXPERIENCE_CATEGORY)}`,
    question: `How does ${sample(
      EXPERIENCE_CATEGORY
    )} affects my company in the long run to benefit all of its' employees?`,
    raisedBy: sample(EMPLOYEES),
    response:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry. ',
    feedback: faker.datatype.number({ min: 1, max: 5, precision: 0.1 })
  };
});

// ----------------------------------------------------------------------

mock.onGet('/api/communications/requests').reply(200, { data: [...requests] });

// ----------------------------------------------------------------------

mock
  .onGet('/api/communications/questions')
  .reply(200, { data: [...questions] });

// ----------------------------------------------------------------------

mock
  .onGet('/api/communications/feedbacks')
  .reply(200, { data: [...feedBacks] });

// ----------------------------------------------------------------------

mock.onPost('/api/communications/request/status').reply(async () => {
  await fakeRequest(3000);
  return [200, { data: [] }];
});

// ----------------------------------------------------------------------

mock.onPost('/api/communications/question').reply(async () => {
  await fakeRequest(3000);
  return [200, { data: [] }];
});
